import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

export default function UpdateDocumentContextInfoCard() {
  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <HelpIcon color="primary" />
          <Typography style={{ paddingLeft: ".25em" }}>
            How to use: Update Document Context
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography style={{ textAlign: "left" }}>
            <p>
              Update Document Context will take a user ID and make sure that the
              users current organisation ID is applied as the context to all
              their Templates and Inspection Documents (Active & Archived).
            </p>
            <ul>
              <li>
                <b>User ID</b> - Customers s12 User ID (eg. user_xxxxx...)
              </li>
              <li>
                <b>Customer Request</b> - Link to the customer interaction
                requesting this be run
              </li>
              <li>
                <b>Region</b> - The region in which the customers data is stored
              </li>
            </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
